import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

async function changeDpjp(register, pasienRm, data) {
  const response = await http
    .putData(`/encounter/ranap/${register}/participant`, {
      type: "dpjp",
      pasien_rm: pasienRm,
      data: data
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function changeRaber(register, pasienRm, data) {
  const response = await http
    .putData(`/encounter/ranap/${register}/participant`, {
      type: "raber",
      pasien_rm: pasienRm,
      data: data
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function regRanap(register, pasienRm) {
  const response = await http
    .postData(`/encounter/ranap`, {
      register_id: register,
      pasien_rm: pasienRm
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getEncounterRanap(register) {
  const response = await http
    .getData(`/encounter/ranap/${register}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getPasienRanapDilayani() {
  const response = await http
    .getData(`/encounter/pasien-ranap-dilayani`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  changeDpjp,
  changeRaber,
  regRanap,
  getEncounterRanap,
  getPasienRanapDilayani
};
